export default __webpack_public_path__ + "static/media/Virtual4.2a550504.webp";